import { Box, Image, useMantineTheme } from '@mantine/core'

import classes from './BackgroundSection.module.css'
import type { BackgroundSectionProps } from './BackgroundSection.types'

export function BackgroundSection({ image }: BackgroundSectionProps) {
  const theme = useMantineTheme()

  return (
    <Box bg={theme.other.colors.blue} className={classes.backgroundSidebar}>
      <Image src={image} />
    </Box>
  )
}
